import React, { Component } from "react";
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import DepartmentAchievers from "../component/DepartmentAchievers";
import DepartmentNumbers from "../component/DepartmentNumbers";
import Footer from "../../../components/common/Footer";
import DepartmentVideo from "../component/DepartmentVideo";

export default class VLSIAbout extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner
          title="Electronics Engineering (VLSI Design & Technology)"
          image="banners/department-cse.jpg"
        />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <DepartmentAchievers department="vlsi" />
                  <DepartmentNumbers
                    text1="Number of students on roll"
                    num1="189"
                    text2="Number of Faculty"
                    num2="7"
                    text3="Number of Faculty with Ph.D"
                    num3="4"
                    text4="Number of technical staff"
                    num4="4"
                    text5="Number of PhD pursuing"
                    num5="3"
                    text6="Number of publication"
                    num6="98"
                    text7="Number of patent"
                    num7="3"
                  />
                  <div className="ttm-service-description">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="ttm_single_image-wrapper">
                          <img
                            className="img-fluid"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/departments/vlsi/about.png"
                            }
                            alt="single-img-eighteen"
                          />
                        </div>
                      </div>
                      <div
                        className="col-md-7 justify"
                        style={{ margin: "auto" }}
                      >
                        <p>
                          The Electronics Engineering (VLSI Design and
                          Technology) program was introduced at Bangalore
                          Institute of Technology (BIT) in the academic year
                          2022-23, with an intake of 60 students. BIT is the
                          first institution in Karnataka to offer a specialized
                          course in VLSI Design and Technology, aimed at
                          addressing the growing demands of the semiconductor
                          industry. As an autonomous institution under
                          Visvesvaraya Technological University (VTU), Belagavi,
                          and recognized by AICTE, New Delhi, BIT strives to
                          equip students with the latest technologies in the
                          VLSI domain to foster sustained growth in the
                          semiconductor sector.
                        </p>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <p>
                          Very-Large-Scale Integration (VLSI) refers to the
                          process of creating integrated circuits (ICs) by
                          designing, implementing, producing, assembling,
                          testing, marking, and packaging chips as a whole. VLSI
                          is commonly associated with chip design, where
                          millions of transistor-based circuits are integrated
                          into a single chip used in various applications such
                          as computing, communication, storage, networking,
                          digital signal processing (DSP),
                          micro-electromechanical systems (MEMS), radio
                          frequency (RF), consumer electronics, cryptography,
                          cryptocurrencies, automotive systems, robotics, space
                          applications, healthcare, smart buildings, and the
                          Internet of Things (IoT). With electronics devices and
                          gadgets becoming integral to daily life, the demand
                          for application-specific integrated circuits (ASICs)
                          and system-on-a-chip (SoC) solutions has skyrocketed.
                          This drive for smaller, more powerful, efficient, and
                          intelligent ICs has led to innovations such as
                          smartphones, home appliances, communication devices,
                          network systems, gaming consoles, and automotive
                          vehicles. The rapid advancement in IC design and
                          production has created a massive demand for skilled
                          VLSI designers. India's Semiconductor Mission (ISM),
                          announced by the government, reflects the nation's
                          commitment to securing a strong position in the $553
                          billion global semiconductor market. With this
                          initiative, budding engineers in India will be
                          well-positioned to enter the semiconductor industry
                          after completing their Bachelor's degree in
                          Electronics Engineering (VLSI Design and Technology).
                          The program aims to bridge the gap between industry
                          requirements and academic knowledge, producing
                          "industry-ready" engineers.
                        </p>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <p>
                          The majority of job opportunities in the VLSI domain
                          revolve around hardware design, module verification,
                          and product testing, which are vital aspects of the
                          VLSI ecosystem. The B.E. Electronics Engineering (VLSI
                          Design and Technology) undergraduate program at BIT
                          introduces students to the functional and operational
                          aspects of chip design, verification, and testing
                          technologies. The program offers a detailed
                          exploration of the challenges and solutions in VLSI
                          design and testing while focusing on emerging and
                          existing technologies in the field. VLSI Design and
                          Technology offers a range of career opportunities with
                          excellent professional growth prospects and attractive
                          salary incentives. Key recruiters in the VLSI sector
                          include semiconductor manufacturing companies,
                          electronic design automation (EDA) firms, and
                          industries relying heavily on integrated circuits
                          (ICs).{" "}
                        </p>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <h4 className="title">
                          Some of the prominent recruiters are
                        </h4>
                      </div>

                      <div className="col-md-12 paddingtop-2 justify">
                        <h5 className="title">Semiconductor Companies</h5>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <ul className="ttm-list ttm-list-style-icon">
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">Intel</span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              TSMC (Taiwan Semiconductor Manufacturing Company)
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Samsung Electronics
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Qualcomm
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              AMD (Advanced Micro Devices)
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Micron Technology
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">NVIDIA</span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Broadcom
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Texas Instruments
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              STMicroelectronics
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <h5 className="title">
                          EDA (Electronic Design Automation) Tool Companies
                        </h5>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <ul className="ttm-list ttm-list-style-icon">
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Cadence Design Systems
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Synopsys
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Siemens Semiconductors
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <h5 className="title">
                          Automotive and Aerospace Companies
                        </h5>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <ul className="ttm-list ttm-list-style-icon">
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">Tesla</span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">Nissan</span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">Boeing</span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Lockheed Martin
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Raytheon Technologies
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <h5 className="title">
                          Consumer Electronics Companies
                        </h5>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <ul className="ttm-list ttm-list-style-icon">
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">Apple</span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">Sony</span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              LG Electronics
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              Panasonic
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <h5 className="title">Research and Development Labs</h5>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <ul className="ttm-list ttm-list-style-icon">
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              IBM Research
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              ARM Holdings
                            </span>
                          </li>
                          <li>
                            <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                            <span className="ttm-list-li-content">
                              National Semiconductor
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <p>
                          In addition to established companies, numerous
                          startups in the VLSI design and semiconductor space
                          are actively seeking engineers with expertise in chip
                          design, simulation, and verification. These companies
                          typically look for candidates skilled in hardware
                          design, digital circuit design, VHDL/Verilog, FPGA,
                          RTL design, ASIC design, simulation, and testing.
                        </p>
                      </div>
                    </div>
                  </div>
                  <DepartmentVideo department="cse" />
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Vision</h4>
                    </div>
                    <p>
                      Empowering cutting-edge innovation through research,
                      industry collaboration and interdisciplinary education
                      leading to distinction in VLSI Design and Technology
                      fields for an enlightened carrier in Semiconductor
                      Industry.{" "}
                    </p>
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Mission</h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon justify">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To provide high-quality education and training to
                          prepare students to become proficient and innovative
                          electronics engineers
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To conduct pioneering research in the electronics
                          domain contributing to global research and develop a
                          strong partnership with semiconductor industries
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To develop versatile, ethnically driven and socially
                          responsible VLSI engineers with a zeal for lifelong
                          learning.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="section-title with-desc text-left clearfix">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">
                        Program Educational Objectives (PEO's)
                      </h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Strong Foundation in VLSI Design and Electronics
                          Engineering : Graduates will possess a solid
                          theoretical and practical foundation in electronics
                          engineering, with a focus on the design, development,
                          and implementation of Very-Large-Scale Integration
                          circuits and systems.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Adaptability to Advancing Technologies : Graduates
                          will demonstrate the ability to swiftly adapt to the
                          evolving landscape of VLSI design, staying current
                          with the latest tools, techniques, and industry
                          standards in areas such as System-on-Chip design, low
                          power design, hardware description languages, and
                          Electronic Design Automation tools
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Commitment to Ethical and Professional Standards :
                          Graduates will uphold high ethical standards and
                          professionalism, ensuring that their VLSI designs
                          prioritize efficiency, sustainability, and contribute
                          positively to society.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Lifelong Learning and Contributions to Industry and
                          Research : Graduates will be equipped for lifelong
                          learning and ongoing professional development, with
                          the ability to make significant contributions to both
                          the semiconductor industry and academic research,
                          particularly in chip design and related fields.
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="ttm-service-single-content-area paddingtop-2">
                    <div className="section-title with-desc text-left clearfix">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h4 className="title">Program Outcomes</h4>
                      </div>
                    </div>
                    <div className="ttm-service-description">
                      <ul className="ttm-list ttm-list-style-icon">
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Engineering Knowledge : Apply knowledge of
                            mathematics, science, and engineering fundamentals
                            to solve complex engineering problems.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Problem Analysis : Identify, formulate, and analyze
                            complex engineering problems using research-based
                            knowledge and methodologies.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Design/Development of Solutions : Design solutions
                            for complex engineering problems that meet specified
                            needs with appropriate consideration for public
                            health and safety, cultural, societal, and
                            environmental factors.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Conduct Investigations : Use research-based
                            knowledge and methods to conduct experiments,
                            analyze data, and synthesize information to provide
                            valid conclusions.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Modern Tool Usage : Create, select, and apply
                            appropriate techniques, resources, and modern
                            engineering tools to complex engineering activities,
                            understanding their limitations.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Engineer and Society : Apply reasoning informed by
                            contextual knowledge to assess societal, health,
                            safety, legal, and cultural issues relevant to
                            professional engineering practice.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Environment and Sustainability : Understand the
                            impact of professional engineering solutions in
                            societal and environmental contexts and demonstrate
                            knowledge of sustainable development.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Ethics : Apply ethical principles and commit to
                            professional ethics and responsibilities in
                            engineering practice.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Individual and Team Work : Function effectively as
                            an individual and as a member or leader in diverse
                            teams and multidisciplinary settings.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Communication : Communicate effectively on complex
                            engineering activities with the engineering
                            community and society at large.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Project Management and Finance : Demonstrate
                            knowledge and understanding of engineering and
                            management principles to manage projects in
                            multidisciplinary environments.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Lifelong Learning : Recognize the need for, and have
                            the preparation and ability to engage in independent
                            and lifelong learning in the context of
                            technological change.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Program Specific Outcomes</h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Graduates will be proficient in designing, verifying,
                          and implementing digital circuits and systems at
                          various levels of abstraction, utilizing advanced EDA
                          tools and methodologies.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Graduates will have the expertise to design
                          energy-efficient VLSI circuits, as well as analog and
                          mixed-signal circuits, with the capability to
                          integrate them onto a single chip.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Graduates will possess a thorough understanding of the
                          VLSI fabrication process, including semiconductor
                          manufacturing techniques, process flows, and the
                          effects of technology scaling on device performance.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DepartmentSidebar department="vlsi" />
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
